import { Info } from 'lucide-react';

import { SummaryCard } from 'src/containers/Escrow/Summary';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { roleOptionsDict, agreementFormOptionsDict } from 'src/pages/SoftwareEscrowOnboarding/Summary/model';
import { useSoftwareEscrow } from 'src/context/software-escrow';

const BasicsCard = () => {
  const {
    softwareEscrow: { currentCompanyRole, agreement },
  } = useSoftwareEscrow();

  const { title: roleTitle, description: roleDescription } = roleOptionsDict[currentCompanyRole!];
  const { title: agreementFormTitle, description: agreementFormDescription } =
    agreementFormOptionsDict[agreement.agreementForm!];

  return (
    <SummaryCard icon={Info} title="Basics" description="Your role and agreement form" note="Non-editable">
      <Table>
        <TableBody>
          <TableRow className="border-0 hover:bg-white">
            <TableCell className="h-10 px-0 w-40 text-xs font-semibold text-muted-foreground py-2.5">Role</TableCell>
            <TableCell data-separator className="h-10 w-5 px-0 pr-1 py-2.5 text-slate-400 text-right">
              :
            </TableCell>
            <TableCell className="h-10 py-2.5">
              <strong className="font-semibold">{roleTitle} — </strong>
              {roleDescription}
            </TableCell>
          </TableRow>
          <TableRow className="hover:bg-white">
            <TableCell className="h-10 px-0 w-40 text-xs font-semibold text-muted-foreground py-2.5">
              Agreement form
            </TableCell>
            <TableCell data-separator className="h-10 w-5 px-0 pr-1 py-2.5 text-slate-400 text-right">
              :
            </TableCell>
            <TableCell className="h-10 py-2.5">
              <strong className="font-semibold capitalize">{agreementFormTitle} — </strong>
              {agreementFormDescription}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </SummaryCard>
  );
};

export default BasicsCard;
